// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__1ReEK","title":"AfterFrontImage_title__2S-IA"};